import defaultClient from 'axios';
export { default as defaultClient } from 'axios';
import axiosRetry from 'axios-retry';
import { authInterceptorError } from './auth-interceptor.js';
import { isServerSide } from '../utils/index.js';
import debug from 'debug';
import { cacheControlInterceptor } from './cache-control-interceptor.js';

const debugLogger = debug('data-api-honey-rest:client');
const throwError = (msg)=>{
    throw new Error(msg);
};
const IDEMPOTENT_HTTP_METHODS = [
    'get',
    'head',
    'options',
    'put',
    'delete'
];
const isRetryableError = (error)=>{
    return error.code !== 'ECONNABORTED' && error.response?.status > 500 && error.response?.status <= 599;
};
const createClient = (config = {})=>{
    let client = {
        get: ()=>throwError('Client not initialized'),
        post: ()=>throwError('Client not initialized'),
        delete: ()=>throwError('Client not initialized'),
        head: ()=>throwError('Client not initialized'),
        options: ()=>throwError('Client not initialized'),
        put: ()=>throwError('Client not initialized'),
        patch: ()=>throwError('Client not initialized')
    };
    client = defaultClient.create({
        // We don't want to expose client side the api url
        baseURL: isServerSide() ? `${process.env.BH_PROXY_API_HOST}${process.env.BH_PROXY_API_PATH}` : undefined,
        _retry_max: process.env.NEXT_PUBLIC_BH_API_RETRY_MAX,
        ...config
    });
    client.defaults.maxRedirects = 0;
    if (isServerSide()) {
        client.defaults.headers.common['Connection'] = 'keep-alive';
    }
    if (!client.defaults.paramsSerializer) {
        client.defaults.paramsSerializer = {};
    }
    client.defaults.paramsSerializer.visitor = function visitor(value, key, path, helpers) {
        const { defaultVisitor , isObject  } = helpers;
        if (isObject(value)) {
            return defaultVisitor(JSON.stringify(value, null, 2), key, path, helpers);
        }
        return defaultVisitor(value, key, path, helpers);
    };
    axiosRetry(client, {
        retries: process.env.NEXT_PUBLIC_BH_API_RETRY_MAX || 5,
        retryDelay: axiosRetry.exponentialDelay,
        retryCondition: (error)=>{
            if (!error.config) {
                // Cannot determine if the request can be retried
                return false;
            }
            return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.includes(error.config.method);
        }
    });
    const authClientInterceptor = client.interceptors.response.use(null, authInterceptorError(client));
    client.defaults.ejectAuthClientInterceptor = ()=>client.interceptors.response.eject(authClientInterceptor);
    client.interceptors.request.use(function(config) {
        debugLogger('calling: %o', config.baseURL + config.url);
        // debugLogger('   method: %o', config.method)
        // debugLogger('   store: %o', config.headers.store)
        // debugLogger('   Authorization: %o', config.headers.Authorization)
        // debugLogger('   headers: %O', config.headers)
        // debugLogger('   data: %O', config.data)
        // debugLogger('   fullConfig: %O', config)
        // process.exit(1)
        return config;
    });
    client.interceptors.response.use(function(response) {
        // debugLogger('   response.data: %O', response.data)
        return response;
    });
    client.interceptors.request.use(cacheControlInterceptor);
    return client;
};

export { createClient };
